export default __webpack_public_path__ + "static/media/building-on-each-other-template.263c4a91.pdf";